import React from 'react';
import './levelinfo.css';
import Button from '../common/button';
import { useNavigate } from "react-router-dom";




const Levelinfo = (props) => {
      const navigate = useNavigate();
    return (
        <main className={`levelinfo ${props.closing ? 'levelinfo-exit' : ''}`}>

            <div className='levelcont2 fade-up'>
                <h1>LEVEL 1</h1>
                <h4 className='lvlinfosub'>Color Cascade</h4>
            </div>

            <section className='levelinstructions'>
                <div className={props.missionchar}></div>

                <article className={`${props.mission} mission-enter`}>
                    <h5 className={props.missiontitle}>
                        MISSION
                    </h5>

                    <h5 className={`${props.substyle} typing-sub`}>
                        {props.sub}
                    </h5>

                    <h5 className={`${props.infostyle} typing-info`}>
                        {props.info}
                    </h5>
                </article>
            </section>

            <article className='btncontainer buttons-enter'>
                <Button
                    color="btn1"
                    type="START PUZZLE"
                    onClick={props.onStart}
                />

                <Button
                    color="btn2"
                    type="BACK"
                    onClick={() => navigate("/levels")}
                />
            </article>

        </main>
    );
}

export default Levelinfo;